import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/risk/(pages)/(list)')({
  component: () => <Outlet />,
});
